
import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const bannerSlice = createSlice({
    name: 'banners',
    loading: false,
    initialState: {
        bannerlist: []
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.bannerlist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.bannerlist = action.payload.data?action.payload.data[0]:[];
        }
    }
});


export const {listReceived,listRequested ,listRequestFailed } = bannerSlice.actions;
//console.log(body);
export const fetchBanners = (body)=> apiCallBegan({
    url: '/banner/list',
    method: 'post',
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});














